import { KPII } from '../interfaces/kpi.interface'
import { KPIService } from '../services/kpi.service'
import { KPIGetListResponseT, KPIGetParamsT, ReportGetListResponseT } from '../types/kpi.types'

const kpiService = new KPIService()

class KPIRealisation implements KPII {
    getDeliveryList(params: KPIGetParamsT): Promise<KPIGetListResponseT> {
        return kpiService.getDeliveryList(params)
    }

    getTelephonyList(params: KPIGetParamsT): Promise<KPIGetListResponseT> {
        return kpiService.getTelephonyList(params)
    }

    uploadDeliveryFile(form_data: FormData): Promise<void> {
        return kpiService.uploadDeliveryFile(form_data)
    }

    uploadTelephonyFile(form_data: FormData): Promise<void> {
        return kpiService.uploadTelephonyFile(form_data)
    }

    getReport(form_data: FormData): Promise<ReportGetListResponseT> {
        return kpiService.getReport(form_data)
    }
}

export const kpi = new KPIRealisation()
